<template>
    <div>
        <section class="item-image">
            <div class="image" v-if="type!='photo'">
                <img :src="'/item/image/'+item_id">
            </div>
            <photo-slider
                :item_id="item_id"
                kind='content'
                v-if="type=='photo'"
            ></photo-slider>
        </section>

        <section id="item-info">
            <div class="item-title">{{ title }}</div>
            <div class="item-date" v-if="item_type_view_status == 1">{{ onSaleDate.replace(/-/g, '.') }}</div>
            <div class="item-type" v-for="tab in tabs" v-if="tab.type===type && item_type_view_status == 1">
                {{ characters[tab.type+'_type'] }}
            </div>
            <div class="item-description" v-if="sabra_access_status==0">
                <span v-html="description"></span>
            </div>
        </section>

        <div v-if="type=='music' || type=='video'">
            <section id="list">
                <ul>
                    <li v-for="(digicon, index) in digicons" v-bind:key="digicon.digicon_id">
                            <span class="title">
                                <a :href="'/purchased/player/' + digicon.digicon_id + '?shuffle_flag=0'" class="music-title">{{ digicon.title }}</a>
                            </span>
                            <button class="btn btn-outline-dark ml-auto" v-if="digicon.favorite_status==0" @click="addFavoriteList(index)">{{ characters.add_favorite_content }}</button>
                            <button class="btn btn-outline-dark ml-auto" v-if="digicon.favorite_status==1" @click="removeFavoriteList(index)">{{ characters.remove_favorite_content }}</button>
                            <!-- <button class="btn btn-outline-dark ml-auto" @click="select(digicon.digicon_id, $event)">{{ characters.add_music_to_playlist }}</button> -->
                    </li>
                </ul>
            </section>

            <section id="buttons" class="d-flex justify-content-center" v-if="0 < digicons.length">
                <!-- <button class="btn btn-dark button" @click="playDigitalContents()">{{ characters.play_shuffle_order }}</button> -->
                <button class="btn btn-dark button" @click="playDigitalContents()">{{ characters.play_contents }}</button>
            </section>
        </div>

        <section id="item-info" v-if="sabra_access_status==1">
            <div class="item-description">
                <span v-html="description"></span>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "purchased-item-detail",
        props: ['title', 'onSaleDate', 'type', 'item_id', 'description', 'item_type_view_status', 'sabra_access_status', 'json_characters'],
        data: function () {
            return {
                tabs: [
                    {type: 'music', title: '音楽'},
                    {type: 'video', title: 'ビデオ'},
                    {type: 'goods', title: 'グッズ'},
                    {type: 'photo', title: '写真・画像'}
                ],
                digicons: [],
                characters: Object,
            }
        },
        mounted() {
            axios.default
                .post('/purchased/digicon/detail/' + this.item_id)
                .then(response => {
                    this.digicons = response.data;
                });
            this.characters = JSON.parse(this.json_characters);
        },
        methods: {
            select: function (s, event) {
                if (s) {
                    const id = Number(s);
                    location.href = `/playlist/add/${id}`;
                }
            },
            playDigitalContents() {
                let digicon_id = this.digicons[0].digicon_id;
                location.href = '/purchased/player/' + digicon_id + '?shuffle_flag=0';
            },
            addFavoriteList: function(index) {
                let digicon_id = this.digicons[index]['digicon_id'];
                axios.default
                    .get('/favorite/content/add/'+digicon_id)
                    .then(response => {
                        let res = response.data[0];
                        if(res.error_message) {
                            console.log('error: '+res.error_message);
                            return;
                        }
                        this.digicons[index]['favorite_status'] = 1;
                        this.digicons[index]['favorite_id'] = res.favorite_id;
                    });
            },
            removeFavoriteList: function(index) {
                let favorite_id = this.digicons[index]['favorite_id'];
                axios.default
                    .get('/favorite/content/remove/'+favorite_id)
                    .then(response => {
                        let res = response.data[0];
                        if(res.error_message) {
                            console.log('error: '+res.error_message);
                            return;
                        }
                        this.digicons[index]['favorite_status'] = 0;
                        this.digicons[index]['favorite_id'] = undefined;
                    });
            },
        }

    }
</script>

<style scoped>

</style>
